/**
 * ModuleDoorOpenState enum.
 * 
 * KotOR JS - A remake of the Odyssey Game Engine that powered KotOR I & II
 * 
 * @file ModuleDoorOpenState.ts
 * @author KobaltBlu <https://github.com/KobaltBlu>
 * @license {@link https://www.gnu.org/licenses/gpl-3.0.txt|GPLv3}
 * @enum
 */
export enum ModuleDoorOpenState {
  DEFAULT   = 0,
  CLOSED    = 0,
  OPEN1     = 1,
  OPEN2     = 2,
  DESTROYED = 3,
};
